exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1Ak_kZ_iLWkZ2CoUCG_iDl{display:flex;max-width:1120px;margin:40px auto;padding:0 40px}._3n8OCHfGeY-1csJxo8-n0j{flex:1 1 auto;min-width:0px;margin-right:40px}.N0Fbg-8gHVUkqqhKVxEXx{width:280px;flex:0 0 auto}@media screen and (max-width: 1025px){._1Ak_kZ_iLWkZ2CoUCG_iDl{display:block}._3n8OCHfGeY-1csJxo8-n0j{margin-right:0}.N0Fbg-8gHVUkqqhKVxEXx{width:auto}}@media screen and (max-width: 530px){._1Ak_kZ_iLWkZ2CoUCG_iDl{margin:20px auto;padding:0 10px}}\n", ""]);

// Exports
exports.locals = {
	"ColWrap": "_1Ak_kZ_iLWkZ2CoUCG_iDl",
	"MainCol": "_3n8OCHfGeY-1csJxo8-n0j",
	"SecondaryCol": "N0Fbg-8gHVUkqqhKVxEXx"
};